/**
 * =====================================================================
 * apps/web/src/lib/stripe/credit-card.ts
 * =====================================================================
 * Política de cobros: Aceptación de TARJETAS DE DÉBITO Y CRÉDITO.
 * Permite tanto crédito como débito para facilitar el registro de usuarios.
 * Bloquea únicamente tarjetas prepago sin soporte de retención o mandato.
 * =====================================================================
 */

export type CardFunding = "credit" | "debit" | "prepaid" | "unknown";

export const CREDIT_CARD_ONLY_MESSAGE =
  "Aceptamos tarjetas de débito y crédito. No se admiten tarjetas prepago virtuales.";

export const PREPAID_CARD_REJECTED_MESSAGE =
  "No se admiten tarjetas prepago. Por favor, introduce una tarjeta de débito o crédito bancaria.";

/** Alias legacy de compatibilidad */
export const DEBIT_CARD_REJECTED_MESSAGE = PREPAID_CARD_REJECTED_MESSAGE;

/** `true` si el funding detectado corresponde a prepago no admitido. */
export function isBlockedFunding(
  funding: CardFunding | string | null | undefined,
): boolean {
  return funding === "prepaid";
}

/** `true` para debit/credit/unknown/ausente (permitidos). */
export function isAllowedFunding(
  funding: CardFunding | string | null | undefined,
): boolean {
  return !funding || funding === "credit" || funding === "debit" || funding === "unknown";
}
